import type { ReactNode } from 'react';

export function AdvancedGroup({ title, children, defaultOpen = false }: { title: string; children: ReactNode; defaultOpen?: boolean }) {
  return (
    <details open={defaultOpen} className="border-t border-[var(--border)] py-2">
      <summary className="tech-label cursor-pointer select-none py-1 marker:content-none">{title}</summary>
      <div className="space-y-3 pt-3">{children}</div>
    </details>
  );
}
